import * as Yup from 'yup';

const phoneRegex = /^\+7\(\d{3}\)\d{3}-\d{2}-\d{2}$/;
const spacesRegex = / /g;
function validatePhone() {
  return this.test('phone', 'Неверный формат номера телефона', (value) => {
    if (value === undefined) {
      return true;
    }
    const v = value.replace(spacesRegex, '');
    return phoneRegex.test(v);
  });
}
Yup.addMethod(Yup.string, 'phone', validatePhone);

const ERR_NAME_REQUIRED = 'Пожалуйста, укажите Ваше имя';
const ERR_EMAIL_REQUIRED = 'Пожалуйста, укажите email';
const ERR_MSG_REQUIRED = 'Пожалуйста, введите текст сообщения';
const ERR_PHONE_REQUIRED = 'Пожалуйста, укажите номер телефона';
const ERR_INVALID_EMAIL = 'Неверный формат email';
const ERR_INVALID_LINK = 'Неверный формат адреса URL';
const ERR_INVALID_NUM = 'Неверный формат числа';

const ERR_SRV =
  'Не удалось отправить ваше сообщение. Пожалуйста, попробуйте позже или свяжитесь с нами другим способом';

const OK_MSG = 'Спасибо! Наш специалист свяжется с вами';

export {
  ERR_NAME_REQUIRED,
  ERR_EMAIL_REQUIRED,
  ERR_MSG_REQUIRED,
  ERR_PHONE_REQUIRED,
  ERR_INVALID_EMAIL,
  ERR_INVALID_LINK,
  ERR_INVALID_NUM,
  OK_MSG,
  ERR_SRV,
};
